import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Landing from "@/pages/Landing";
import LegalNotice from "@/pages/LegalNotice";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";
import Insights from "@/pages/Insights";
import InsightsSeoChecklist from "@/pages/InsightsSeoChecklist";
import ComparadorGLP1 from "@/pages/ComparadorGLP1";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              {/* Landing */}
              <Route path="/" element={<Landing />} />
              <Route path="/es" element={<Landing />} />

              {/* Blog (bilingual) */}
              <Route path="/blog" element={<BlogList lang="ca" />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/es/blog" element={<BlogList lang="es" />} />
              <Route path="/es/blog/:slug" element={<BlogArticle />} />

              {/* Legal */}
              <Route path="/avis-legal" element={<LegalNotice />} />
              <Route path="/aviso-legal" element={<LegalNotice />} />
              <Route path="/politica-privacitat" element={<PrivacyPolicy />} />
              <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
              <Route path="/politica-cookies" element={<CookiePolicy />} />

              {/* GLP-1 comparator — Spanish market */}
              <Route path="/comparador-glp1" element={<ComparadorGLP1 />} />

              {/* Internal — unlinked, noindex */}
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/seo" element={<InsightsSeoChecklist />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
